
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import ProductsList from './components/ProductsList';
import ProductForm from './components/ProductForm';
import StockMovements from './components/StockMovements';
import InventoryAdjustment from './components/InventoryAdjustment';
import LocationsManagement from './components/LocationsManagement';
import StockAlerts from './components/StockAlerts';

export default function ProductsPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('products');
  const [showForm, setShowForm] = useState(false);
  const [showAdjustment, setShowAdjustment] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const navigate = useNavigate();

  const handleAddProduct = () => {
    setEditingProduct(null);
    setShowForm(true);
  };

  const handleEdit = (product: any) => {
    setEditingProduct(product);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingProduct(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-6 lg:ml-64 pt-24">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6 flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => navigate('/dashboard')}
                  className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                  title="Retour au tableau de bord"
                >
                  <i className="ri-arrow-left-line text-xl text-gray-600"></i>
                </button>
                <div>
                  <h1 className="text-3xl font-bold text-gray-900 mb-2">Gestion des Stocks</h1>
                  <p className="text-gray-600">Gestion des produits, stocks et emplacements</p>
                </div>
              </div>
              
              {activeTab === 'products' && (
                <button
                  onClick={handleAddProduct}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors shadow-lg flex items-center space-x-2 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-add-line text-lg"></i>
                  <span>Nouveau Produit</span>
                </button>
              )}
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
              <div className="flex border-b border-gray-200">
                <button
                  onClick={() => setActiveTab('products')}
                  className={`px-6 py-4 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeTab === 'products'
                      ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-product-hunt-line mr-2"></i>
                  Référentiel Produits
                </button>
                <button
                  onClick={() => setActiveTab('movements')}
                  className={`px-6 py-4 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeTab === 'movements'
                      ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-arrow-left-right-line mr-2"></i>
                  Mouvements
                </button>
                <button
                  onClick={() => setActiveTab('alerts')}
                  className={`px-6 py-4 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeTab === 'alerts'
                      ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-alarm-warning-line mr-2"></i>
                  Alertes
                </button>
                <button
                  onClick={() => setActiveTab('inventory')}
                  className={`px-6 py-4 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeTab === 'inventory'
                      ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-file-list-3-line mr-2"></i>
                  Inventaire
                </button>
                <button
                  onClick={() => setActiveTab('locations')}
                  className={`px-6 py-4 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeTab === 'locations'
                      ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-map-pin-line mr-2"></i>
                  Emplacements
                </button>
              </div>
            </div>

            {activeTab === 'products' && (
              <ProductsList onEdit={handleEdit} onAdd={handleAddProduct} />
            )}
            
            {activeTab === 'movements' && (
              <StockMovements />
            )}
            
            {activeTab === 'alerts' && (
              <StockAlerts />
            )}
            
            {activeTab === 'inventory' && (
              <InventoryAdjustment />
            )}
            
            {activeTab === 'locations' && (
              <LocationsManagement />
            )}
          </div>
        </main>
      </div>

      {showForm && (
        <ProductForm
          product={editingProduct}
          onClose={handleCloseForm}
        />
      )}
    </div>
  );
}
